import { motion } from "framer-motion";
import { Home, TrendingUp, Scale, Gavel } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: Home,
    title: "Prodej nemovitostí",
    href: "/sluzby/prodej",
    description:
      "Kompletní servis od prvního kontaktu až po předání klíčů a převod médií. Profesionální prezentace, cílený marketing, právní služby vč. bezpečné úschovy samozřejmostí.",
  },
  {
    icon: TrendingUp,
    title: "Tržní odhad",
    href: "/sluzby/odhad",
    description:
      "Bezplatný odhad tržní hodnoty vaší nemovitosti na základě aktuálních dat z trhu a 30 let zkušeností s prodejem v Praze.",
  },
  {
    icon: Scale,
    title: "Dědictví – odhad",
    href: "/sluzby/dedictvi",
    description:
      "Odhad nemovitosti pro dědické řízení. Rychle, spolehlivě a v souladu se všemi právními požadavky.",
  },
  {
    icon: Gavel,
    title: "Aukce",
    href: "/sluzby/aukce",
    description:
      "Prodej nemovitosti formou aukce nejlepší nabídce. Transparentní proces, kde si prodávající sám vybere kupujícího.",
  },
];

const ServicesSection = () => {
  return (
    <section id="sluzby" className="section-padding bg-background">
      <div className="container-luxury">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-14"
        >
          <span className="badge-remax mb-6">Služby</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground">
            Co pro vás mohu udělat
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -8, transition: { duration: 0.3, ease: "easeOut" } }}
            >
              <Link
                to={s.href}
                className="glass-card-hover p-6 flex flex-col items-center text-center h-full block group cursor-pointer"
              >
                <motion.div
                  whileHover={{ scale: 1.15, rotate: 8 }}
                  transition={{ type: "spring", stiffness: 400, damping: 15 }}
                  className="icon-glossy w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                  style={{
                    background: 'linear-gradient(135deg, #002349, hsl(215 65% 42%))',
                    boxShadow: '0 8px 25px -6px hsl(215 65% 42% / 0.35), inset 0 1px 0 rgba(255,255,255,0.12)',
                  }}
                >
                  <s.icon className="h-5 w-5 text-white/90" strokeWidth={1.5} />
                </motion.div>
                <h3 className="font-heading font-semibold text-lg text-foreground mb-2">
                  {s.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {s.description}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
